import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { setRightUploadAdData } from '../../../../../modules/actions/rights'
import { clearCreateLineItem, createLineItem } from '../../../../../modules/actions/lineItems'
import { selectedTikTokAdAccountSelector } from '../../../../../modules/selectors/adAccounts'

import { LINE_ITEM } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'
import { TIKTOK_PLATFORM } from '../../../../../constants/selectLists/platformList'

import { transformLineItemValuesToBE } from './formatters'
import { LIST_ITEM_OPTION, OPTION_EXISTING_LIST_ITEM } from '../../../../../hooks/formHooks/listItemFormHooks/fields'

const useLineItemCreateHandlers = props => {
  PropTypes.checkPropTypes(propTypes, props, 'prop', 'useLineItemCreateHandlers')

  const dispatch = useDispatch()

  const {
    lineItems,
    right,
    campaign,
    shouldPopulateExistingValues,
    pixelIdFromExistingLineItem,
    externalActionFromExistingLineItem,
    interests,

    // todo PBR-1358 Remove after finalizing lineItem from
    // reusableShowBidPriceStep,
    // isBidTypeCustomPopulated,
    // reusableShowPixelStep,
    tikTokRegions,
    setSuccessSubmit
  } = props

  const { id: selectedTikTokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)

  const onSubmit = useCallback(
    values => {
      if (values[LIST_ITEM_OPTION] === OPTION_EXISTING_LIST_ITEM) {
        const selectedLineItemFullData = lineItems.find(lineItem => values[LINE_ITEM] === lineItem.id)

        dispatch(setRightUploadAdData({ lineItem: selectedLineItemFullData }, TIKTOK_PLATFORM))

        setSuccessSubmit(true)
      } else {
        const transformedData = transformLineItemValuesToBE({
          values,
          adAccountId: selectedTikTokAdAccountId,
          right,
          campaign,
          tikTokRegions,
          shouldPopulateExistingValues,
          pixelIdFromExistingLineItem,
          externalActionFromExistingLineItem,
          interests

          // todo PBR-1358 Remove after finalizing lineItem from
          // reusableShowBidPriceStep,
          // isBidTypeCustomPopulated,
          // reusableShowPixelStep,
        })

        dispatch(createLineItem(transformedData, TIKTOK_PLATFORM))
      }
    },
    [
      dispatch,
      lineItems,
      selectedTikTokAdAccountId,
      right,
      campaign,
      tikTokRegions,
      setSuccessSubmit,
      shouldPopulateExistingValues,
      pixelIdFromExistingLineItem,
      externalActionFromExistingLineItem,
      interests

      // todo PBR-1358 Remove after finalizing lineItem from
      // reusableShowBidPriceStep,
      // isBidTypeCustomPopulated,
      // reusableShowPixelStep,
      // pixelIdFromExistingLineItem,
      // externalActionFromExistingLineItem,
    ]
  )

  const clearCreateLineItemHandler = useCallback(() => {
    dispatch(clearCreateLineItem())
  }, [dispatch])

  return {
    onSubmit,
    clearCreateLineItemHandler
  }
}

const propTypes = {
  lineItems: PropTypes.array.isRequired,
  right: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  reusableShowBidPriceStep: PropTypes.bool.isRequired,
  isBidTypeCustomPopulated: PropTypes.bool.isRequired,
  reusableShowPixelStep: PropTypes.bool.isRequired,
  pixelIdFromExistingLineItem: PropTypes.string,
  externalActionFromExistingLineItem: PropTypes.string,
  setSuccessSubmit: PropTypes.func.isRequired
}

export default useLineItemCreateHandlers
